import { Stack } from '@mui/material';
import { MprcButton, MprcRequestErrorReport, MprcSpinnerIndicator } from 'components';
import { TrainingNoticeItemDtoPaginatedList } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NoticeViewer } from 'views/lms/publication/views/NoticeViewer';
import { useEnrollmentViewContext } from '..';

/////////////////////////////////////////////////////////////////////////////////////

export const EnrollmentNotices: React.FC = () => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const { enrollmentId, enrollment: { isPreview, classroomId } } = useEnrollmentViewContext();
    const pageSize = 5;

    const [loading, setLoading] = useState<boolean>(false);
    const [viewData, setViewData] = useState<TrainingNoticeItemDtoPaginatedList>({
        items: [],
        pageNumber: 1,
        pageSize,
        totalPages: 0,
        totalRows: 0
    });

    const [viewError, setViewError] = useState<any>();
    const [pageNumber, setPageNumber] = useState<number>(1);

    const missingNotices = viewData.totalPages == 1 ? 0 : viewData.totalRows - (pageNumber * pageSize);

    /////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        setLoading(true);
        api.v1.enrollment.getEnrollmentNotices({
            enrollmentId: isPreview ? null : enrollmentId,
            classroomId: isPreview ? classroomId : null,
            pageNumber: pageNumber,
            pageSize
        })
            .then(response => {
                setViewData(state => ({ ...response.data, items: [...state.items, ...response.data.items] }));
            })
            .catch(e => setViewError(e))
            .finally(() => setLoading(false));
    }, [pageNumber]);

    return (
        <>
            {viewError != null
                ? <MprcRequestErrorReport error={viewError} />
                :
                <>
                    <Stack direction="column" spacing={1} sx={{ width: "640px", margin: "0 auto" }}>
                        {viewData.items.map(item => <NoticeViewer key={item.publicationId} publication={item} />)}
                        {loading
                            ? <MprcSpinnerIndicator />
                            : missingNotices > 0 &&
                            <div>
                                <MprcButton
                                    variant="contained"
                                    color="success"
                                    onClick={() => setPageNumber(pageNumber + 1)}
                                >
                                    {t("Monitoring.Classroom.Notices.RemainingNotices", { count: missingNotices })}
                                </MprcButton>
                            </div>
                        }
                    </Stack>

                </>
            }
        </>
    );
};
